<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'
    
   export default {
      page: {
         title: "Add Order",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data: () => {
         //const datetime = moment().add(1, 'days').format("YYYY-MM-DD") + "T00:00";
         const datetime = moment().format("YYYY-MM-DD") + "T00:00";
         const date = moment().format("YYYY-MM-DD");
         return {
            loading: true,
            title: "Add Order",
            items: [
               {
                  text: "Orders",
                  href: "/orders",
               },
               {
                  text: "Add Order",
                  active: true,
               },        
            ],

            min_date: date,
            min_datetime: datetime,

            order: {
               customer_id: '',
               location: '',
               latitude: '',
               longitude: '',
               fuel_station_id: '',
               delivery_datetime: '',
               payment_type: '',
               address: '',
               special_instructions: '',
               order_type: '',
               coupon_code: '',
               mobile: '',
            },

            //customer_id: 0,
            customer_keyword: '',
            customer_visible: false,

            // customers: [
            //    {
            //       id: null,
            //       customer_name: "+91 1234567890 | Customer 1"
            //    },
            //    {
            //       id: null,
            //       customer_name: "+91 1234567891 | Customer 2"
            //    },
            //    {
            //       id: null,
            //       customer_name: "+91 1234567892 | Customer 3"
            //    },
            //    {
            //       id: null,
            //       customer_name: "+91 1234567893 | Customer 4"
            //    },
            // ],

            customers: [],

            order_location: '',
            order_marker: { position: { lat: null, lng: null } },
            order_center: { lat: null, lng: null },
            order_current_place: null,

            order_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},

            // fuels: [
            //    {
            //       id: 1,
            //       fuel: "Gasoline",
            //       price: "5",
            //       quantity: 10,
            //       ordered: 1,
            //    },
            //    {
            //       id: 2,
            //       fuel: "Diesel",
            //       price: "4",
            //       quantity: '',
            //       ordered: 0,
            //    }
            // ],

            stations: [],
            fuels: [],
            confirm: {},

            show_total: false,

         };
      },
      mounted() {},

      created() {
         this.fetchFuelStations();
      },

      methods: {

         getToken() {
            if (localStorage.getItem('sigofuel_admin')) {
               var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
               if(sigofuel_admin.token) {
                  this.token = sigofuel_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchCustomers() {
            let url = "api/admin/getCustomers?keyword=" + this.customer_keyword;         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.customers = responseData.customers;
                  this.customer_visible = true;
            })
            .catch((err) => console.log(err));
         },

         fetchFuelStations() {
            let url = "api/admin/getFuelStations";         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.stations = responseData.fuel_stations;
            })
            .catch((err) => console.log(err));
         },

         fetchFuels() {
            let url = "api/admin/fuel_station/fuels?fuel_station_id=" + this.order.fuel_station_id;         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  var fuels = responseData.fuels;

                  // this.fuels.forEach(obj => {
                  //    this.$set(obj, 'ordered', 0);
                  //    this.$set(obj, 'quantity', '');
                  //    this.$set(obj, 'amount', '');
                    
                  // });

                  // for(var i=0; i<this.fuels.length; i++) {
                  //    this.$set(this.fuels[i], 'ordered', 0);
                  //    this.$set(this.fuels[i], 'quantity', '');
                  //    this.$set(this.fuels[i], 'amount', '');
                  // }
                  this.fuels = [];
                  fuels.forEach(obj => {
                     var fuel = {};
                     this.$set(fuel, 'fuel_en', obj.fuel_en);
                     this.$set(fuel, 'fuel_so', obj.fuel_so);
                     this.$set(fuel, 'id', obj.id);
                     this.$set(fuel, 'price', obj.price);
                     this.$set(fuel, 'ordered', 0);
                     this.$set(fuel, 'quantity', '');
                     this.$set(fuel, 'amount', '');   
                     this.fuels.push(fuel); 
                  }); 
                  console.log(this.fuels);
            })
            .catch((err) => console.log(err));
         },

         closeCustomerSearch() {
            this.customer_visible = false;       
            this.customer_keyword = '';
            this.order.customer_id = '';
         },

         setCustomer() {
            this.customer_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.customer_visible = false;
         },

         //sets the position of marker when dragged
         orderHandleMarkerDrag(e) {
            this.order_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         orderPanToMarker() {
            this.$refs.orderMapRef.panTo(this.order_marker.position);
            this.$refs.orderMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         orderHandleMapClick(e) {
            this.order_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         orderSetPlace(place) {
            this.order_current_place = place;
            if(this.order_current_place) {
               const marker = {
                  lat: this.order_current_place.geometry.location.lat(),
                  lng: this.order_current_place.geometry.location.lng(),
               };
               this.order_center = marker;
               this.order_marker.position = marker;
               this.order_location = place.formatted_address;
            }
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },   

         getTotal(fuel)  {
            fuel.amount = parseFloat(fuel.price) * parseInt(fuel.quantity);
         },

         confirmOrder() {

            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/order/getValues";  
       
            let formData = new FormData();
            formData.append("customer_id", this.order.customer_id); 
            formData.append("fuel_station_id", this.order.fuel_station_id); 
            formData.append("payment_type", this.order.payment_type); 
            formData.append("order_type", this.order.order_type); 
            formData.append("address", this.order.address); 
            formData.append("special_instructions", this.order.special_instructions); 
            formData.append("latitude", this.order_marker.position.lat); 
            formData.append("longitude", this.order_marker.position.lng); 

            let delivery_date = '';
            let delivery_time = '';

            if(this.order.order_type == 2 && this.order.delivery_datetime != '') {

               delivery_date  = moment(this.order.delivery_datetime).format("YYYY-MM-DD");
               delivery_time = moment(this.order.delivery_datetime).format("hh:mm:ss");
            } 

            formData.append("delivery_date", delivery_date); 
            formData.append("delivery_time", delivery_time);         

            var i = 0;
            this.fuels.forEach(obj => {
               if(obj.ordered == 1) {
                  formData.append('fuel_type_ids[' + i + ']', obj.id);
                  formData.append('quantities[' + i + ']', obj.quantity);
                  i++;
               }
            });
            formData.append("coupon_code", this.order.coupon_code);  
            formData.append("mobile", this.order.mobile);  
            formData.append("location", this.order_location);  
            this.$axios
            .post(url, formData, config)
            .then((res) => {
               if(res.status == 200) {
                  
                     this.confirm = res.data.data;
                     this.showModal('confirm-modal');
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
                  
                  console.log(res);
            })
            .catch((error) => {
                  if (error.response) {
                     if(error.response.status == 422) {               
                        if (error.response.data) {
                           this.errors = error.response.data.message;
                        } 
                        this.$swal("", error.response.statusText, "error");
                        
                     } else if(error.response.status == 500) {
                        this.$swal("", error.response.statusText, "error");

                     } else if(error.response.status == 401) {
                        this.$swal("", error.response.statusText, "error");
                        this.$router.push({ name: "login" });
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", error.message, "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         createOrder() {

            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/order/add";  
            this.loading = true;
       
            let formData = new FormData();
            
            formData.append("customer_id", this.order.customer_id); 
            formData.append("fuel_station_id", this.order.fuel_station_id); 
            formData.append("payment_type", this.order.payment_type); 
            formData.append("order_type", this.order.order_type); 
            formData.append("address", this.order.address); 
            formData.append("special_instructions", this.order.special_instructions); 
            formData.append("latitude", this.order_marker.position.lat); 
            formData.append("longitude", this.order_marker.position.lng); 

            let delivery_date = '';
            let delivery_time = '';

            if(this.order.order_type == 2 && this.order.delivery_datetime != '') {

               delivery_date  = moment(this.order.delivery_datetime).format("YYYY-MM-DD");
               delivery_time = moment(this.order.delivery_datetime).format("hh:mm:ss");
            } 

            formData.append("delivery_date", delivery_date); 
            formData.append("delivery_time", delivery_time);         

            var i = 0;
            this.fuels.forEach(obj => {
               if(obj.ordered == 1) {
                  formData.append('fuel_type_ids[' + i + ']', obj.id);
                  formData.append('quantities[' + i + ']', obj.quantity);
                  i++;
               }
            });
            formData.append("coupon_code", this.order.coupon_code);  
            formData.append("mobile", this.order.mobile); 
            formData.append("location", this.order_location); 
           
            this.$axios
            .post(url, formData, config)
            .then((res) => {
               if(res.status == 200) {
                  
                     // this.clearForm();
                     this.$router.push({ name: 'orders'});
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
                  
                  console.log(res);
            })
            .catch((error) => {
                  if (error.response) {
                     if(error.response.status == 422) {               
                        if (error.response.data) {
                           this.errors = error.response.data.message;
                        } 
                        this.$swal("", error.response.statusText, "error");
                        
                     } else if(error.response.status == 500) {
                        this.$swal("", error.response.statusText, "error");

                     } else if(error.response.status == 401) {
                        this.$swal("", error.response.statusText, "error");
                        this.$router.push({ name: "login" });
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", error.message, "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         // clearForm() {   
             
         //    this.order.customer_id = "";
         //    this.customer_keyword = "";
         //    this.order.fuel_station_id = "";
         //    this.order.payment_type = "";
         //    this.order.order_type = "";
         //    this.order.address = "";
         //    this.order.special_instructions = "";
         //    this.order.latitude = "";
         //    this.order.longitude = "";
         //    this.order.delivery_datetime = "";
         //    this.order.location = "";
         //    this.order.mobile = "";
         //    this.order.coupon_code = "";
         //    this.order.quantities = "";
         //    this.order_marker.position = { lat: null, lng: null };
         //    this.order_center = { lat: null, lng: null };
         //    this.order_location = "";

         //    this.fuels = [];

         //    this.errors = {};
         // },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'orders' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <form class="form-horizontal" role="form" @submit.prevent="confirmOrder()">
                     <b-card header-class="bg-transparent border-light" class="border border-light">
                     
                        <div class="row"> 

                           <b-col md="12" class="form-group">
                              <label class="control-label">Customer <span class="text-danger">*</span></label>                        

                              <div class="search-select">
                                 <span class="search-close" v-if="customer_visible" @click="closeCustomerSearch"><i class="dripicons dripicons-cross"></i></span>
                                    
                                 <b-form-input v-model="customer_keyword"  @keyup="fetchCustomers()"  v-bind:class="{ 'is-invalid': Boolean(errors.customer_id) }" autocomplete="off" placeholder="Search customer mobile here..."></b-form-input>
                                 <div v-for="(val, index) in errors.customer_id" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                 </div>   
                                 <b-form-select class="form-control" v-if="customer_visible && Boolean(customers.length)" v-model="order.customer_id" :select-size="customers.length < 10 ? (customers.length <= 1 ? 2 : customers.length) : 10" @change="setCustomer">
                                    <b-form-select-option v-for="customer in customers" :key="customer.id" :value="customer.user_id">
                                       {{ customer.country_code }} {{ customer.mobile }}|
                                       <span v-if="customer.name_en">{{ customer.name_en }}</span>
                                       <span v-else>{{ customer.name_so }}</span>
                                    </b-form-select-option>
                                 </b-form-select>

                                 <b-form-select class="form-control" v-if="customer_visible && !Boolean(customers.length)" v-model="order.customer_id" :select-size="2">                  
                                    <b-form-select-option value="" disabled>No data results...</b-form-select-option>
                                 </b-form-select>

                                 <!-- <div v-for="(val, index) in errors.customer_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div> -->
                              </div>                           

                           </b-col>
         

                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="orderSetPlace" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.location) }"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="order_location"/>
                              
                              <div v-for="(val, index) in errors.location" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                              </div>
                                 
                              <GmapMap v-if="order_location"
                                 :center="order_center"
                                 :zoom="18"
                                 map-style-id="order-roadmap"
                                 :options="order_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="orderMapRef"
                                 @click="orderHandleMapClick">
                                    <GmapMarker
                                       :position="order_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="orderHandleMarkerDrag"
                                       @click="orderPanToMarker"
                                    />
                              </GmapMap>                          
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="order_marker.position.lat" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>

                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                              
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="order_marker.position.lng" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>

                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Address <span class="text-danger">*</span></label>
                              <b-form-textarea v-model="order.address" row="2" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></b-form-textarea>

                              <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label>Fuel Station <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="order.fuel_station_id" @change="fetchFuels()" v-bind:class="{ 'is-invalid': Boolean(errors.fuel_station_id) }">
                                 <option value="">Select</option>
                                 <option :value="station.user_id" v-for="station in stations" :key="station.id">{{station.name_en}}</option>
                              </select>

                              <div v-for="(val, index) in errors.fuel_station_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>                        
                     
                     </b-card>

                     <!-- <b-card header-class="bg-transparent border-light" class="border border-light" v-if="order.fuel_station_id"> -->
                     <b-card header-class="bg-transparent border-light" class="border border-light" v-if="fuels.length">
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                              <label class="control-label">Fuels <span class="text-danger">*</span></label>  
                              <b-row>
                                 <b-col md="6" v-for="(fuel, index) in fuels" :key="index">
                                    <b-row class="mb-2">
                                       <b-col md="12">
                                          <b-form-checkbox
                                             v-model="fuel.ordered"
                                             :value="1"
                                             :unchecked-value="0">
                                             <p class="ms-2 mb-0">{{fuel.fuel_en}} | Price: ${{fuel.price}}</p>
                                          </b-form-checkbox>
                                       </b-col>

                                       <b-col md="12">
                                          <div v-if="fuel.ordered==1">
                                 
                                             <label class="control-label">Quantity (in litres) <span class="text-danger">*</span></label>
                                             <!-- <b-form-input type="number" step="1" min="1" max="1000" @blur="getTotal(fuel)" v-model="fuel.quantity"></b-form-input> -->
                                             <b-form-input type="number" step="1" min="1" max="1000" v-model="fuel.quantity" v-bind:class="{ 'is-invalid': Boolean(errors.quantities) }"></b-form-input>
                                          </div>
                                          <p v-if="fuel.amount" class="small">Amount: {{fuel.amount}}</p>
                                       </b-col>                                       
                                    </b-row>
                                 </b-col>                                

                              </b-row>

                              <div v-for="(val, index) in errors.fuel_type_ids" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>

                              <div v-for="(val, index) in errors.quantities" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }} </p>
                              </div>
                           </b-col>
                        </div>
                     </b-card>

                     <!-- <b-card header-class="bg-transparent border-light" class="border border-light" v-if="order.fuel_station_id"> -->
                     <b-card header-class="bg-transparent border-light" class="border border-light">
                        <div class="row"> 

                           <b-col md="6" class="form-group">
                              <label class="control-label">Order Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="order.order_type" name="order_type" v-bind:class="{ 'is-invalid': Boolean(errors.order_type) }"> 
                                 <div class="form-check-inline"> 
                                    <b-form-radio value="1" class="mr-5">
                                       Normal
                                    </b-form-radio> 
                                    
                                 </div>
                                 <div class="form-check-inline">  
                                    <b-form-radio value="2">
                                       Scheduled
                                    </b-form-radio>
                                    
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.order_type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group" v-if="order.order_type==2">
                              <label class="control-label">Delivery Date & Time <span class="text-danger">*</span></label>
                              <b-form-input type="datetime-local" v-model="order.delivery_datetime" :min="min_datetime" v-bind:class="{ 'is-invalid': Boolean(errors.delivery_date) || Boolean(errors.delivery_time) }"></b-form-input>

                              <div v-for="(val, index) in errors.delivery_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>

                              <div v-for="(val, index) in errors.delivery_time" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" class="form-group">
                              <label class="control-label">Payment Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="order.payment_type" name="payment_type" v-bind:class="{ 'is-invalid': Boolean(errors.payment_type) }"> 
                                 <div class="form-check-inline"> 
                                    <b-form-radio value="1" class="mr-5">
                                       Cash Payment
                                    </b-form-radio> 
                                    
                                 </div>
                                 <div class="form-check-inline">  
                                    <b-form-radio value="2">
                                       Mobile Payment
                                    </b-form-radio>
                                    
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.payment_type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Coupon Code</label>
                              <b-form-input v-model="order.coupon_code"  v-bind:class="{ 'is-invalid': Boolean(errors.coupon_code) }"></b-form-input>

                              <div v-for="(val, index) in errors.coupon_code" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Special Instructions </label>
                              <b-form-textarea v-model="order.special_instructions" row="3" v-bind:class="{ 'is-invalid': Boolean(errors.special_instructions) }"></b-form-textarea>

                              <div v-for="(val, index) in errors.special_instructions" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>
                     </b-card> 

                     <div class="row mt-3">
                        <div class="12">
                           <button class="btn btn-primary me-2" type="submit">Save</button>
                           <router-link :to="{ name: 'orders' }" class="btn btn-light">Cancel</router-link>
                        </div>
                     </div>
                  </form>   
               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="confirm-modal" id="confirm-modal" title="Confirm Order" hide-footer >
         <b-form @submit.prevent="createOrder()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <div class="table-responsive ">
                     <table class="table mb-0 w-100">
                        <tbody>
                           <tr v-for="fu in confirm.fuels" :key="fu.id">
                              <th>{{fu.quantity}} litre {{fu.fuel_en}} (${{fu.price}}x{{fu.quantity}})</th>
                              <th>:</th>
                              <td class="text-right">${{fu.total}}</td>
                           </tr>

                           <tr>
                              <th>Total Fuel Price</th>
                              <th>:</th>
                              <td class="text-right">${{confirm.total_fuel_price}}</td>
                           </tr>                                       
                           <tr>
                              <th>Delivery Charge (12 km)</th>
                              <th>:</th>
                              <td class="text-right">${{confirm.delivery_charge}}</td>
                           </tr>

                           <tr>
                              <th>Promo Discount</th>
                              <th>:</th>
                              <td class="text-right">${{confirm.promotion_discount}}</td>
                           </tr>

                           <tr>
                              <th>Tax</th>
                              <th>:</th>
                              <td class="text-right">${{confirm.tax}}</td>
                           </tr>

                           <tr>
                              <th>Other Charges</th>
                              <th>:</th>
                              <td class="text-right">${{confirm.other_charges}}</td>
                           </tr>

                           <tr>
                              <th>Total</th>
                              <th>:</th>
                              <th class="text-right">${{confirm.total}}</th>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  
               </b-col>    
               
               <b-col lg="12">
                  <div class="page-loader" v-if="!loading">
                     <b-button type="submit" class="me-3" variant="primary">Confirm</b-button>
                     <b-button class="" variant="light" @click="hideModal('confirm-modal')">Cancel</b-button>
                  </div>

                  <div class="page-loader" v-else>
                        <img src="@/assets/images/preloaderspin.gif" style="width: 50px;"/>
                  </div>

               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
